import React from "react";
import { Props } from "./types";
import { ActivityWatcher } from "../activityWatcher";
import { VisibilitySwitch } from "../visibilitySwitch";

function VisibilityWatcher(props: Props) {
  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <ActivityWatcher
          className={
            typeof props.className === "function"
              ? props.className({ isVisible })
              : props.className
          }
          blur={() => {
            if (isVisible) {
              hide();
              props.blur && props.blur();
            }
          }}
          focus={() => {
            if (!isVisible) {
              show();
              props.focus && props.focus();
            }
          }}
        >
          {props.children(isVisible, show, hide)}
        </ActivityWatcher>
      )}
    />
  );
}

export { VisibilityWatcher };
